/**
 * Normaliza um telefone (qualquer formato vindo do ERP) para o formato discável
 * pela rota de saída do PBX: **0 + DDD + número** (convenção BR "0 + DDD").
 *
 * Exemplos:
 *   '5585991613813'    → '085991613813'  (tira o código do país 55)
 *   '85991613813'      → '085991613813'
 *   '(85) 99161-3813'  → '085991613813'
 *   '08533334444'      → '08533334444'   (já normalizado, idempotente)
 *
 * TODO: o prefixo de saída ('0') é a convenção do tenant atual. Quando o motor
 * suportar formato de saída configurável por rota/tenant, migrar isto pra config
 * em vez de hardcode. Ver follow-up de "force route" no originate.
 */
/**
 * Heurística: o número é um ramal interno (não um telefone externo)? Ramais do
 * PBX têm 3-5 dígitos; telefone BR tem >= 8 (DDD + número). Usado pra NÃO fazer
 * lookup de cliente no ERP em chamada interna (ramal↔ramal) — com um número
 * curto o IXC dá match espúrio e mostra um cliente errado no card do webphone.
 * O ideal seria consultar o extension_map do motor, mas o tamanho cobre 99%.
 */
export function isInternalExtension(raw?: string): boolean {
  const n = (raw ?? '').replace(/\D/g, '');
  return n.length > 0 && n.length <= 5;
}

export function toDialableBr(raw: string): string {
  let n = (raw ?? '').replace(/\D/g, '');
  if (!n) return '';
  // Remove o código do país BR (55) quando presente: 55 + 10/11 dígitos nacionais.
  if (n.startsWith('55') && (n.length === 12 || n.length === 13)) {
    n = n.slice(2);
  }
  // Número nacional (DDD + 8/9 dígitos) → prefixa o '0' da rota de saída.
  if ((n.length === 10 || n.length === 11) && !n.startsWith('0')) {
    n = '0' + n;
  }
  return n;
}
